import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import MessageModal from '../container/MessageModal';
import TextControl from '../container/customizedInputs/TextControl';
import { errorClassification } from '../errorHandler';

import usuariosServices from '../services/usuariosServices';

const RecuperoClave = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [recupero, setRecupero] = useState({
    token: "",
    password: "",
    password_confirmation: ""
  });
  const [email, setEmail] = useState('');
  const [renderHTML, setRenderHTML] = useState(false);
  const [esCambioDeClave, setEsCambioDeClave] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  let { token } = useParams();

  useEffect(() => {
    if(token){
      setEsCambioDeClave(true)
      setRecupero({...recupero,
        token: token
      })
    } else {
      setEsCambioDeClave(false)
    }
  }, []);

  useEffect(() => {
    if(authInformation.autenticado === true){
      navigate(`/`);
    } else {
      setRenderHTML(true)
    }

  }, [authInformation]);


  const olvidoClave = async () => {
    try {
      const data = await usuariosServices.olvidoClave(email);

      handleShowModal(data.message)
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const recuperoClave = async () => {
    try {
      const data = await usuariosServices.recuperoClave(recupero);

      handleShowModal(data.message)
      navigate(`/ingreso`);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRecupero({...recupero,
      [name]: value
    })
  }

  const handleInputEmail = (e) => {
    const { name, value } = e.target;
    setEmail(value)
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    if(token){
      recuperoClave()
    } else {
      olvidoClave()
    }
  }

  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              <div className="card mb-3">
                <div className="card-body">
                  {
                    esCambioDeClave ? (
                      <>
                        <h5 className="card-title">Cambie su clave</h5>
                        <div className='row mb-3'>
                          <div className='col-sm-6'>
                            <TextControl
                              value={recupero.password}
                              name={'password'}
                              handleInput={handleInput}
                              type='password'
                              label='Nueva clave'
                              />
                          </div>
                          <div className='col-sm-6'>
                            <TextControl
                              value={recupero.password_confirmation}
                              name={'password_confirmation'}
                              handleInput={handleInput}
                              type='password'
                              label='Repita la nueva clave'
                              />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <h5 className="card-title">Olvidaste la clave ?</h5>
                        <TextControl
                          value={email || ''}
                          name={'email'}
                          handleInput={handleInputEmail}
                          label='Ingrese su email para recuperar la clave'
                          />
                      </>
                    )
                  }

                </div>
              </div>

              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">Cambiar clave</button>
                <button className="btn btn-outline-secondary px-4" type='button' onClick={() => navigate(-1)}>Volver</button>
              </div>

            </form>
          </main>
        )
      }

     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default RecuperoClave;